import { IMAGES_KIND } from "../../../layout-editor/manager/image-processor/image-processor.manager";
import { ApiBaseFront } from "../../front/api-base-front";

export type PrintImagePostRequest = {
  kijshopCd: string,
  shopOrderId: string,
  id: string,
  kind: string,
  filename: string,
  exifCreated: string,
  exifColorSpace?: string,
  exifOrientation?: number,
  exifMake?: string,
  exifModel?: string,
  width?: number,
  height?: number,
  hash?: string,
  data: File,
  dataThumb? : string,
}

export class ApiPrintImagePost extends ApiBaseFront {
  constructor(param: PrintImagePostRequest) {
    const {
      kijshopCd,
      shopOrderId,
      ..._param
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/images/upload`,
      'JSON',
      _param,
    );
  }
}

export type PrintImagesGetResponse = {
  fileList: PrintImagesDataEntity[],
}

export type PrintImagesDataEntity = {
  orgFilename:	string,
  id:	string,
  filename:	string,
  path:	string,
  pathThumb:	string,
  exifCreated:	string,
  exifColorSpace:	string,
  exifMake:	string,
  exifModel:	string,
  exifOrientation: number,
  width:	number,
  height:	number,
  hash:	string,
  selectID:	string,
}

export class ApiPrintImagesGet extends ApiBaseFront<PrintImagesGetResponse> {
  constructor(param: { kijshopCd: string, shopOrderId: string, kind?: string }) {
    const {
      kijshopCd,
      shopOrderId,
      kind,
    } = param;

    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/images`,
      'JSON',
      {
        kind: kind ?? IMAGES_KIND.PRINT,
      },
    );
  }
}

export type PrintImageDeleteRequest = {
  kijshopCd: string,
  shopOrderId: string,
  kind: string,
  filename: string,
}

export class ApiPrintImagesDelete extends ApiBaseFront {
  constructor(param: PrintImageDeleteRequest) {
    const {
      kijshopCd,
      shopOrderId,
      ...request
    } = param;

    super(
      'DELETE',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/images`,
      'JSON',
      request,
    );
  }
}

export type PrintImagesCopyPostRequest = {
  kijshopCd: string,
  shopOrderId: string,
  srcKind: string,
  dstKind: string,
  srcFilename: string,
  dstFilename: string,
};
export class ApiPrintImagesCopyPost extends ApiBaseFront {
  constructor(param: PrintImagesCopyPostRequest) {
    const {
      kijshopCd,
      shopOrderId,
      ...request
    } = param;
    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/images/copy`,
      'JSON',
      request,
    );
  }
}
